import React from 'react'
import styled from 'styled-components';
import { motion } from 'framer-motion'
import GithubCalendar from 'react-github-calendar'
const Github = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.6,
                staggerChildren: 0.3
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    const calendarVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        }
    };

    const statsVariants = {
        hover: {
            scale: 1.05,
            y: -5,
            transition: {
                duration: 0.3,
                ease: "easeInOut"
            }
        }
    };

    return (
        <MainContainer style={{ marginTop: "-20px" }}>
            <motion.h1 
                style={{ color: "#01a479", textTransform: "uppercase" }}
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                Days I Worked
            </motion.h1>
            <Container>
                <motion.div
                    variants={calendarVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <GithubCalendar 
                        username='mohitkss' 
                        year={new Date().getFullYear()} 
                        blockSize={15} 
                        blockMargin={5} 
                        fontSize={16} 
                    />
                </motion.div>
            </Container>
            <motion.h1 
                style={{ color: "#01a479", textTransform: "uppercase" }}
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                My Statistics
            </motion.h1>
            <motion.div 
                className='stats'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
            >
                <motion.img 
                    align="center" 
                    src="https://github-readme-stats.vercel.app/api?username=mohitkss&show_icons=true&locale=en" 
                    alt="mohitkss"
                    variants={itemVariants}
                    whileHover={statsVariants.hover}
                />
                <motion.img 
                    align="center" 
                    src="https://github-readme-streak-stats.herokuapp.com/?user=mohitkss&" 
                    alt="mohitkss"
                    variants={itemVariants}
                    whileHover={statsVariants.hover}
                />
            </motion.div>
        </MainContainer>
    )
}

const Container = styled.div`
    margin:auto;
    width:80%;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-bottom:50px;
    flex-direction:column;
    border: 10px solid #01a479;
    border-radius:50px 5px 50px 5px;
    padding:30px 10px 30px 10px;
`

const MainContainer = styled.div`
    .stats{
        width:80%;
        margin:auto;
        display:flex;
        justify-content:center;
        border-radius:50px;
        margin-bottom:50px;
    }

    .stats>img{
        padding:20px 10px 20px 10px;
    }

    @media only screen and (min-width: 769px) and (max-width:1110px){
        .stats{
            flex-direction:column; 
        }

    }

    @media only screen and (min-width: 481px) and (max-width:768px){
        
        .stats{
            flex-direction:column; 
        }
    }


    @media only screen and (min-width:320px) and (max-width:480px){
        .stats{
            width:90%;
            flex-direction:column; 
        }
    }

    @media only screen and (max-width: 319px){
        .stats{
            width:90%;
            flex-direction:column; 
        }
    }

`

export default Github